import client, {QueryOptions, MutationOptions} from "@irati/utils/services/apollo"
import {Tag} from "@irati/types"
import {QueryTagsArgs, QueryTagArgs, MutationCreateTagArgs, MutationUpdateTagArgs} from "@irati/types/ops"
import PBService from "@irati/utils/services"
import listFormat, {ListFormatArray} from "@irati/utils/services/graph/utils/listFormat"

import tagQuery, {tagKey} from "./queries/getTag"
import tagsQuery, {tagsKey} from "./queries/listTags"
import createTagMutation, {createTagKey} from "./mutation/createTag"
import updateTagMutation, {updateTagKey} from "./mutation/updateTag"

class TagService extends PBService {
  get({id, withChildren = false}: QueryTagArgs, options: QueryOptions = {}): Promise<Tag> {
    const variables = {id, withChildren}
    return client.query({...options, query: tagQuery, variables}).then(({data}) => data[tagKey])
  }

  list({withChildren = false, ...args}: QueryTagsArgs, options: QueryOptions = {}): Promise<ListFormatArray<Tag>> {
    const variables = {...args, withChildren}
    return client.query({...options, query: tagsQuery, variables}).then(({data}) => listFormat(data[tagsKey]))
  }

  create({withChildren = false, data}: MutationCreateTagArgs, options: MutationOptions = {}) {
    const variables = {data, withChildren}
    return client.mutate({...options, mutation: createTagMutation, variables}).then((res) => res.data[createTagKey])
  }

  update({withChildren = false, data}: MutationUpdateTagArgs, options: MutationOptions = {}) {
    const variables = {data, withChildren}
    return client.mutate({...options, mutation: updateTagMutation, variables}).then((res) => res.data[updateTagKey])
  }
}

const tagService = new TagService({errorHandlers: []})

export default tagService
